import { render } from "./TeacherClassText.vue?vue&type=template&id=1b9c3e9e&scoped=true&ts=true"
import script from "./TeacherClassText.vue?vue&type=script&lang=ts"
export * from "./TeacherClassText.vue?vue&type=script&lang=ts"

import "./TeacherClassText.vue?vue&type=style&index=0&id=1b9c3e9e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9c3e9e"]])

export default __exports__